import { Helmet } from 'react-helmet-async';

const Seo = (props) => {
  return (
      <Helmet>
        <title>{props.title}</title>
        <meta name="description" content={props.description} />
        <meta name="keywords" content={props.keywords} />
        <meta name="author" content={'Lorenzo Giralda'} />

      {/* FACEBOOK METATAG */}
      {/* <meta property="og:url" content={props.url} />
      <meta property="og:title" content={props.title} />
      <meta property="og:description" content={props.description} />
      <meta property="og:image" content={props.immagine} /> */}
      </Helmet>
  );
}

export default Seo;
